import { useState } from "react";
const useModal = () => {
  const [modalIsOpen, setIsOpen] = useState(false);

  const openModal = () => {
    setIsOpen(true);
  };

  const closeModal = () => {
    setIsOpen(false);
  };
  return {
    modalIsOpen,
    openModal,
    closeModal,
  };
};
export default useModal;



// WEBPACK FOOTER //
// ./src/utils/useModal.js